export enum PlayerStatType {
  Deaths,
  CraftsOrUpgrades,
  Builds,
  Jumps,
  Cheats,
  EnemyHits,
  EnemyKills,
  EnemyKillsLastHits,
  PlayerHits,
  PlayerKills,
  HitsTakenEnemies,
  HitsTakenPlayers,
  ItemsPickedUp,
  Crafts,
  Upgrades,
  PortalsUsed,
  DistanceTraveled,
  DistanceWalk,
  DistanceRun,
  DistanceSail,
  DistanceAir,
  TimeInBase,
  TimeOutOfBase,
  Sleep,
  ItemStandUses,
  ArmorStandUses,
  WorldLoads,
  TreeChops,
  Tree,
  TreeTier0,
  TreeTier1,
  TreeTier2,
  TreeTier3,
  TreeTier4,
  TreeTier5,
  LogChops,
  Logs,
  MineHits,
  Mines,
  MineTier0,
  MineTier1,
  MineTier2,
  MineTier3,
  MineTier4,
  MineTier5,
  RavenHits,
  RavenTalk,
  RavenAppear,
  CreatureTamed,
  FoodEaten,
  SkeletonSummons,
  ArrowsShot,
  TombstonesOpenedOwn,
  TombstonesOpenedOther,
  TombstonesFit,
  DeathByUndefined,
  DeathByEnemyHit,
  DeathByPlayerHit,
  DeathByFall,
  DeathByDrowning,
  DeathByBurning,
  DeathByFreezing,
  DeathByPoisoned,
  DeathBySmoke,
  DeathByWater,
  DeathByEdgeOfWorld,
  DeathByImpact,
  DeathByCart,
  DeathByTree,
  DeathBySelf,
  DeathByStructural,
  DeathByTurret,
  DeathByBoat,
  DeathByStalagtite,
  DoorsOpened,
  DoorsClosed,
  BeesHarvested,
  SapHarvested,
  TurretAmmoAdded,
  TurretTrophySet,
  TrapArmed,
  TrapTriggered,
  PlaceStacks,
  PortalDungeonIn,
  PortalDungeonOut,
  BossKills,
  BossLastHits,
  SetGuardianPower,
  SetPowerEikthyr,
  SetPowerElder,
  SetPowerBonemass,
  SetPowerModer,
  SetPowerYagluth,
  SetPowerQueen,
  SetPowerAshlands,
  SetPowerDeepNorth,
  UseGuardianPower,
  UsePowerEikthyr,
  UsePowerElder,
  UsePowerBonemass,
  UsePowerModer,
  UsePowerYagluth,
  UsePowerQueen,
  UsePowerAshlands,
  UsePowerDeepNorth,
  Count,
}